(function ($, real) {
    'use strict';

    let requestStack = [];          // Storage for latest requests.
    const requestStackLimit = 200;  // How many requests to keep in the stack.
    const pendingRequestStack = []; // Stack of requests pending for retry.
    const retryTimeout = 3000;      // Amount of milliseconds to retry a network errored request.
    const retryLimit = 5;           // How many times a network errored request is retried.

    // Used to track when we noticed a version change through an AJAX request.
    let lastVersionChangeSeenAt = null;
    // After seeing an update through AJAX requests, this variable defines how long we wait for
    // the update notification to arrive through websockets before triggering a reload. The
    // actual reload will be done on the next AJAX request.
    const updateReloadTreshold = 60 * 5 * 1000;

    const checkOptionsMatch = function (a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    };

    const getRequestFromStack = function (stack, url, options) {
        let request = null;
        real.loopReverse(stack, function (loopRequest) {
            if (loopRequest.request.url === url && checkOptionsMatch(loopRequest.options, options)) {
                request = loopRequest;
                return false;
            }
        });
        return request;
    };

    const removeRequestFromStack = function (stack, url, options) {
        real.loop(stack, function (loopRequest, i) {
            if (loopRequest.request.url === url && checkOptionsMatch(loopRequest.options, options)) {
                stack.splice(i, 1);
                return false;
            }
        });
    };

    const checkPreviousRequest = function (url, options, request) {
        // Check if request is already pending OR if the same request was done less than min delay ago.
        const previousRequest = getRequestFromStack(requestStack, url, options);
        if (previousRequest === null) {
            // There was no previous request to the same url with same options.
            return true;
        }

        // We found a previous request to the same url with same request method.
        const timeSinceLatestRequest = Date.now() - previousRequest.request.startedAt;
        if (timeSinceLatestRequest >= options.minDelayToRequestAgain) {
            // The previous request was done later than configured minDelayToRequestAgain limit.
            return true;
        }

        // The latest request was done earlier than the minimum delay to request again.
        // Check if this request is already pending.
        let pendingRequest = getRequestFromStack(pendingRequestStack, url, options);
        if (pendingRequest !== null) {
            // A new request to the same url with same options is already pending, do not add another pending request.
            return false;
        }

        const timeUntilTryAgain = options.minDelayToRequestAgain - timeSinceLatestRequest;
        pendingRequest = request;
        pendingRequest.timeoutId = setTimeout(function () {
            // Remove from pending requests.
            removeRequestFromStack(pendingRequestStack, url, options);

            // Then do the pending request again.
            real.ajax(url, options);
        }, timeUntilTryAgain);

        // Push the request to the pending requests stack.
        pendingRequestStack.push({
            options: options,
            request: pendingRequest
        });

        return false;
    };

    const checkShowErrorNotification = function (url, options, response) {
        if (real.window.isUnloading()) {
            // The window is unloading (user is leaving/reloading the page), do not show error notification.
            return;
        }

        if (options.showErrorNotification === false) {
            // The showErrorNotification is defined as false in options, do not show error notification.
            return;
        }

        if (typeof options.showErrorNotification === 'function' && options.showErrorNotification(response) === false) {
            // The showErrorNotification is defined as a function in options and that function returned false, do not show error notification.
            return;
        }

        // For all other cases the error notification is shown.
        if (response && response.responseJSON && response.responseJSON.errors && response.responseJSON.errors.length > 0 && response.responseJSON.errors[0].error) {
            real.notification.show('<i class="fa fa-light fa-ban mr-2" aria-hidden="true"></i>' + response.responseJSON.errors[0].error.message, 'danger');
        } else {
            let content = '<i class="fa fa-light fa-ban mr-2" aria-hidden="true"></i>AJAX request to URI "' + url + '" failed with error code ' + response.status + '.';
            if (real.dom.$html.data('admin-uri')) {
                content += ' <a href="' + real.dom.$html.data('admin-uri') + '/manager/errors" ' +
                    'target="_blank" rel="noopener noreferrer nofollow" class="no-check-href">View error</a>';
            }
            real.notification.show(content, 'danger');
        }
    };

    const getResponseHeaders = function (jqXHR) {
        var responseHeaders = {};

        jqXHR.getAllResponseHeaders().split('\n').forEach(function (header) {
            if (header === '') {
                return;
            }

            var arr, name, val;

            arr = header.split(':');
            name = arr.shift();
            val = real.trim(arr.join(':'));

            // getAllResponseHeaders returns lower-case-headers, change to Lower-Case-Headers
            name = name.split('-').map(function (word) {
                return word.slice(0, 1).toUpperCase() + word.slice(1);
            }).join('-');

            responseHeaders[name] = val;
        });

        return responseHeaders;
    };

    const checkRetry = function (url, response, options) {
        var retryCodes = {
            0: 'Network Error'
            //500 : 'Internal Server Error'
        };

        if (options.type === 'POST') {
            // This is a POST request.
        } else if (options.type === 'GET') {
            // This is a GET request. Add some response codes to be retried.
            retryCodes[408] = 'Request Timeout';
            retryCodes[429] = 'Too Many Requests';
            retryCodes[502] = 'Bad Gateway';
            retryCodes[503] = 'Service Unavailable';
            retryCodes[504] = 'Gateway Timeout';
        } else {
            // What kind of request is this? Will not retry the AJAX request.
            console.log('Will not retry, because request type ' + options.type + ' is not either GET or POST');
            return false;
        }

        if (options.aborted) {
            // Will not retry, because the request was intentionally aborted.
            return false;
        }

        if (typeof retryCodes[response.status] === 'undefined') {
            // Will not retry, because response code is not one in the retryCodes array.
            return false;
        }

        if (typeof options.retryCount === 'undefined') {
            options.retryCount = 0;
        }

        if (options.retryCount >= retryLimit) {
            // Will not retry, because the failed request has been already retried max amount of times.
            return false;
        }

        // Will retry the failed request in retryTimeout milliseconds.
        console.log('Will retry the failed request in ' + retryTimeout + ' milliseconds.', url, options);
        setTimeout(function () {
            options.retryCount++;
            real.ajax(url, options);
        }, retryTimeout);

        return true;
    };

    real.ajax = function (url, options) {
        var stack, jqXHR, request, jQueryAjaxSettings;

        // Store the call stack.
        stack = new Error().stack;

        if (typeof options.type === 'undefined') {
            options.type = 'GET';
        }

        if (options.type === 'POST' && !options.data) {
            options.data = '{}';
        }

        // If this option is not specifically set to false -> the system will wait for
        // the websocket to be ready (either connected and authenticated or then failed
        // for some reason) before executing the AJAX request. If the websocket is
        // already opened and authenticated -> execute the request immediately.
        if (typeof options.waitForWebsocket === 'undefined') {
            const willConnectToWebsocket = document.documentElement.getAttribute('data-uwebsocket-uri') !== null;
            options.waitForWebsocket = willConnectToWebsocket;
        }

        request = {
            url: url,
            method: options.type,
            status: null,
            requestHeaders: null,
            responseHeaders: null,
            response: null,
            startedAt: Date.now(),
            completedAt: null
        };

        if (options.minDelayToRequestAgain) {
            if (!checkPreviousRequest(url, options, request)) {
                // The previous request was made less than configured min delay ago.
                return;
            }
        }

        // Push the request to stack (will be updated later upon request is completed).
        requestStack.push({
            options: options,
            request: request
        });
        requestStack = requestStack.slice(0, requestStackLimit);

        // Merge default headers with user-defined headers.
        options['headers'] = {
            'X-Real4-Window-Pubsub-Topic-Id': real.dom.$html.data('real4-window-pubsub-topic-id'),
            'X-Howspace-WebsocketId': real.realtime.uwebsocket?.getConnectionId() || '',
            ...options['headers'],
        };

        // Needs to be a copy
        jQueryAjaxSettings = {...options};

        jQueryAjaxSettings.request = request;

        jQueryAjaxSettings.error = function (response) {
            if (jQueryAjaxSettings.aborted) {
                // The request was intentionally aborted.
                return;
            }

            if (response && response.responseText) {
                try {
                    response.responseJSON = JSON.parse(response.responseText);
                } catch (e) {
                    // We got an error response, but it's not JSON.
                }
            }

            if (checkRetry(url, response, jQueryAjaxSettings)) {
                return;
            }

            let sessionExpired = false;
            if (response.status === 403) {
                real.ajax.loopErrors(response, function (loopError) {
                    if (loopError.code === 403 && loopError.message === 'Authenticated session required.') {
                        // Looks like user doesn't have a valid session so re-direct user to root url.
                        sessionExpired = true;
                    }
                });
            }

            if (sessionExpired === true) {
                setTimeout(function () {
                    window.location = real.baseUri + '/?session_expired=1';
                }, 1000);
                return;
            }

            if (typeof options.error === 'function') {
                options.error(response);
            }

            checkShowErrorNotification(url, options, response);

            if (typeof options.logError === 'function' && !options.logError(response)) {
                // The options.logError is a function and it returned false.
                return;
            }

            if (options.logError === false) {
                // The options.logError is false.
                return;
            }

            if (response.status === 422 || response.status === 502 || response.status === 503 || response.status === 504) {
                // We will not log validation or infra/connection issues as errors.
                return;
            }

            if (real.window.isUnloading()) {
                // The window is unloading (user is leaving/reloading the page), do not log the error.
                return;
            }

            const errorMessage = 'AJAX ' + options.type + ' ' + url + ' failed: ' + JSON.stringify(response);
            const errorUrl = real.cdnUri + '/assets/js/real/ajax.js';
            const errorLineNumber = 1;
            const errorColumnNumber = 1;

            const error = new Error(errorMessage);

            if (stack) {
                // Replace the error stack with the stack generated inside this method.
                // This way we get info about what actually called the real.ajax method.
                error.stack = real.errorlogger.cleanErrorStack(stack);
            }

            error.responseHeaders = getResponseHeaders(jqXHR);

            if (jQueryAjaxSettings && jQueryAjaxSettings.data) {
                error.dataPayload = jQueryAjaxSettings.data;
            }

            real.errorlogger.sendErrorToServer(errorMessage, errorUrl, errorLineNumber, errorColumnNumber, error);
        };

        // Global AJAX complete handler
        jQueryAjaxSettings.complete = function (response) {
            if (jQueryAjaxSettings.aborted) {
                // The request was intentionally aborted.
                return;
            }

            const responseHeaders = getResponseHeaders(jqXHR);
            const responseData = {
                text: response.responseText
            };

            try {
                responseData.json = JSON.parse(responseData.text);
            } catch (e) {
                // We got a response, but it's not JSON.
            }

            request.requestHeaders = this.headers;
            request.responseHeaders = responseHeaders;
            request.status = jqXHR.status;
            request.response = responseData;

            request.completedAt = Date.now();
            request.duration = request.completedAt - request.startedAt;

            if (typeof options.complete === 'function') {
                options.complete(response);
            }

            const versionFromHeaders = responseHeaders['X-Howspace-Version'] || null;
            const versionFromDataAttributes = document.documentElement.dataset.howspaceVersion;
            if (versionFromHeaders !== null && versionFromHeaders !== versionFromDataAttributes) {
                // Server responded with a different version number. Howspace is in the middle of updating the version.
                const now = performance.now();
                if (lastVersionChangeSeenAt === null) {
                    // This is the first time we see a version update, so we just store the time.
                    lastVersionChangeSeenAt = now;
                    console.log("HS: Noticed version change", versionFromHeaders);
                } else if (now - lastVersionChangeSeenAt > updateReloadTreshold) {
                    // We're delaying the reload because typically the system will notify about
                    // the update through websockets. The point is to avoid a loop when the servers
                    // are still updating (and we're running the old and new versions side by side).
                    console.log("HS: Triggering version change", versionFromHeaders);
                    real.window.reloadPageOrNotifyUser('layout_version_updated');
                    lastVersionChangeSeenAt = null;
                }
            }

            if (typeof howspace !== 'undefined' && howspace.activityTracker.isIdle() && document.hasFocus()) {
                // User was disconnected due to being idle and now made an AJAX request while the document has focus.
                setTimeout(() => {
                    real.window.reloadPageOrNotifyUser('layout_disconnected_due_to_inactivity', false);
                }, 1000);
            }
        };

        if (options.waitForWebsocket) {
            real.realtime.onReady(function () {
                jqXHR = $.ajax(url, jQueryAjaxSettings);
            });
        } else {
            jqXHR = $.ajax(url, jQueryAjaxSettings);
        }

        jQueryAjaxSettings.abort = () => {
            jQueryAjaxSettings.aborted = true;
            jqXHR?.abort();
        };

        return jQueryAjaxSettings;
    };

    real.ajax.getLatestRequests = function () {
        return requestStack;
    };

    real.ajax.loopErrors = function (response, loopFn) {
        let errors = response?.errors || response?.responseJSON?.errors || null;
        if (typeof errors === 'object' && errors !== null) {
            real.loop(errors, (obj) => {
                loopFn(obj.error);
            });
        }
    };

    real.ajax.handleResponse = function (url, response, jQueryAjaxSettings) {
        if (!response) {
            return response;
        }

        try {
            response = JSON.parse(response);
        } catch (e) {
            // We got a success response, but it's not JSON.
            let message = 'Response is not valid JSON.';

            if (response.substring(0, 1) === '{') {
                message += ' First character is { so the request probably got an incomplete response.';
            } else if (response.substring(0, 1) === '<') {
                message += ' First character is < so the response is probably HTML.';
            } else if (response.length === 0) {
                message += ' The response is an empty string.';
            } else {
                message += ' First character is NOT { or < and response is NOT an empty string. This is interesting...';
            }

            jQueryAjaxSettings.error({
                status: 406,
                message: message,
                response: response
            });
        }

        if (!response || !response.request_stats) {
            return response;
        }

        let relativeUrl = url;
        if (url.match(/^https?:\/\//) !== null) {
            // Get relative URL from the absolute URL.
            const urlObject = new URL(url);
            relativeUrl = urlObject.pathname + urlObject.search;
        }

        const stats = response.request_stats;
        real.logRequestStats(
            jQueryAjaxSettings.request.method,
            relativeUrl,
            stats.execution_time_ms,
            stats.queries,
            stats.mem_peak_usage_mb,
            stats.link_to_admin_app
        );
        delete response.request_stats;

        const hasSequentialKeys = function (keys) {
            return keys[0] == '0' && keys.every((key, index) => {
                return keys[index + 1] === undefined || parseInt(key) < parseInt(keys[index + 1]);
            });
        };

        const keys = Object.keys(response);
        if (keys.length === 0) {
            // Response is empty after deleting 'request_stats' property, make it an empty array.
            return [];
        }

        if (hasSequentialKeys(keys)) {
            // Response has sequential numeric keys after deleting 'request_stats' property.
            // It's supposed to be an array, not an object.
            return Object.values(response);
        }

        return response;
    };

})(jQuery, real);
